import React from 'react';
import styles from './ShooseSection.module.scss';
import { useNavigate } from 'react-router-dom';
import moreContent from '../../../assets/landingpage/more-content.png';
import yourContent from '../../../assets/landingpage/your-content.png';
import yourBrand from '../../../assets/landingpage/your-brand.png';

const ShooseSection = () => {
  const navigate = useNavigate();

  return (
    <section className={styles.shooseSection}>
      <div className={styles.container}>
        <h2 className={styles.title}>Why Choose Vocable.ai?</h2>
        <p className={styles.subtitle}>
          You’re great at what you do. You have deep expertise and a wealth of
          knowledge to share. You know consistent content builds authority and
          attracts clients. But creating high-impact content across multiple
          platforms? It's overwhelming, time-consuming and repetitive...(just
          the thought of it burns you out, we know!) Enter Vocable—your complete
          content ecosystem in one click.
        </p>

        <div className={styles.features}>
          <div className={styles.featureCard}>
            <div className={styles.icon}>
              <img src={moreContent} alt="Content creation" />
            </div>
            <h3>You'll create more content in a day than most do in a month</h3>
            <p>
              One click generates 30 days of content, organized into a content
              plan with ready-to-review posts. No more piecing together random
              content ideas.
            </p>
          </div>

          <div className={styles.featureCard}>
            <div className={styles.icon}>
              <img src={yourContent} alt="Autopilot" />
            </div>
            <h3>Your content strategy runs on autopilot (finally!)</h3>
            <p>
              While other tools generate single posts in isolation, we generate
              content ecosystems that support your overall business goals.
            </p>
          </div>

          <div className={styles.featureCard}>
            <div className={styles.icon}>
              <img src={yourBrand} alt="Brand voice" />
            </div>
            <h3>Your brand voice stays consistent as you scale</h3>
            <p>
              We scan your website to instantly generate your brand profile,
              ensuring every content strategy resonates with your brand
              messaging.
            </p>
          </div>
        </div>

        <button className={styles.cta} onClick={() => navigate('sign-up')}>
          Start your FREE Trial
        </button>
      </div>
    </section>
  );
};

export default ShooseSection;
